import { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

import {
  ConfigProvider,
  Space,
  Table,
  Tag,
  Input,
  Flex,
  InputNumber,
  Button,
  Alert,
  message,
  DatePicker,
  Select,
} from "antd";
const { RangePicker } = DatePicker;

import { API, URL } from "@/config/api";

import dayjs from "dayjs";

import { ICONS } from "@/assets";
import CustomModal from "@/components/CustomModal";
const { TextArea } = Input;

import { ColumnReportBukuBesar } from "../../../library/FormColumn";

import jsPDF from "jspdf";
import "jspdf-autotable";

import { createStyles } from "antd-style";
const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const ReportBukuBesarPage = () => {
  const { styles } = useStyle();
  const [data, setData] = useState([]);
  const [dateString, setDateString] = useState(["", ""]);
  const [loading, setLoading] = useState(false);

  const [options, setOptions] = useState([]); // State untuk menyimpan options
  const [selectedData, setSelectedData] = useState("");

  const extendedColumn = [...ColumnReportBukuBesar.columns];

  const [messageApi, contextHolder] = message.useMessage();

  const onChange = (date, dateString) => {
    setDateString(dateString);
  };

  const getData = async () => {
    try {
      setLoading(true);
      const response = await API.get(
        URL.BUKU_BESAR +
          `?start=${dateString[0]}&end=${dateString[1]}&acc=${
            selectedData || ""
          }`
      );
      setData(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      message.error("Data failed to fetch!");
      setLoading(false);
    }
  };

  // get Data Account
  useEffect(() => {
    // Fungsi untuk fetch data dari API
    const fetchOptions = async () => {
      setLoading(true); // Set loading ke true saat memulai fetch
      try {
        const res = await API.get(URL.MASTER_ACC); // Ganti URL sesuai API Anda
        const data = res.data.data;

        const formattedOptions = data.map((item) => ({
          value: item.noAcc,
          label: `${item.noAcc}`,
        }));

        setOptions(formattedOptions);
      } catch (error) {
        console.error("Error fetching options:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  useEffect(() => {
    getData();

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [dateString, selectedData]);

  const exportToExcel = async () => {
    const date = dayjs(); // Get current date
    const getMonthName = date.format("MMM");
    const formattedDate = date.format("MMM-YY");

    const filteredMonth = [
      ...new Set(
        data.map((item) => {
          const date = new Date(item.tgl);
          return `${date.getFullYear()}-${date.getMonth()}`; // Simpan sebagai "YYYY-MM"
        })
      ),
    ]
      .map((item) => {
        const [year, monthIndex] = item.split("-").map(Number); // Pisahkan "YYYY-MM"

        return {
          year,
          nummberMonth: item,
          month: new Date(year, monthIndex).toLocaleString("en-US", {
            month: "short",
          }), // Konversi ke format singkat
        };
      })
      .sort((a, b) => a.month - b.month || a.month - b.month)
      .map(({ year, month, nummberMonth }) => ({ year, month, nummberMonth }));

    const workbook = new ExcelJS.Workbook();

    filteredMonth.forEach((sheetInfo) => {
      const filteredData = data.filter((e) => {
        const date = new Date(e.tgl);
        const monthName = date.toLocaleString("en-US", { month: "short" }); // Konversi bulan ke format "Feb"
        const year = date.getFullYear(); // Ambil tahun

        return monthName === sheetInfo.month && year === sheetInfo.year;
      });

      const worksheet = workbook.addWorksheet(sheetInfo.month);

      // Tambahkan header utama
      worksheet.mergeCells("A1:H1");
      const header1 = worksheet.getCell("A1");
      header1.value = "BUKU BESAR";
      header1.font = { bold: true, size: 24 };
      header1.alignment = { horizontal: "center", vertical: "middle" };
      header1.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      header1.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };

      worksheet.mergeCells("A2:H2");
      const header3 = worksheet.getCell("A2");
      header3.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "ffffff" }, // white background
      };

      // Tambahkan sub-header dengan tanggal
      worksheet.mergeCells("A3:H3");
      const header2 = worksheet.getCell("A3");
      header2.value = sheetInfo.month + "-" + sheetInfo.year;
      header2.font = { bold: true, size: 32 };
      header2.alignment = { horizontal: "center", vertical: "middle" };
      header2.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      header2.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };

      worksheet.getRow(4).height = 25;

      // Tambahkan header kolom
      const headers = [
        "TANGGAL",
        "NO. BUKTI",
        "NOMOR AKUN",
        "NAMA AKUN",
        "KETERANGAN",
        "DEBIT",
        "KREDIT",
        "SALDO",
      ];
      headers.forEach((header, index) => {
        const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
        cell.value = header;
        cell.font = { bold: false, size: 12 };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFBDD7EE" }, // Light blue background
        };
        cell.border = {
          top: { style: "medium" },
          left: { style: "medium" },
          bottom: { style: "medium" },
          right: { style: "medium" },
        };
      });

      let currentUser = null;
      let currentUsername = null;
      let rowIndex = 5; // Mulai dari baris ke-5

      filteredData.forEach((item, rowIndex) => {
        if (currentUser !== null && currentUser !== item.noAcc) {
          // Hitung total debit dan kredit untuk noAcc sebelumnya
          let totalDebit = filteredData
            .filter((d) => d.noAcc === currentUser && d.kategori === "debit")
            .reduce((sum, d) => sum + d.amount, 0);

          let totalKredit = filteredData
            .filter((d) => d.noAcc === currentUser && d.kategori === "kredit")
            .reduce((sum, d) => sum + d.amount, 0);

          // Tambahkan baris total di bawah kelompok data sebelumnya
          const totalRow = worksheet.addRow();

          totalRow.getCell(1).value = "TOTAL";
          totalRow.getCell(2).value = "";
          totalRow.getCell(3).value = currentUser;
          totalRow.getCell(4).value = currentUsername;
          totalRow.getCell(5).value = "";
          totalRow.getCell(6).value = totalDebit != 0 ? totalDebit : "";
          totalRow.getCell(7).value =
            totalKredit != 0 ? Math.abs(totalKredit) : "";
          totalRow.getCell(8).value = totalDebit - Math.abs(totalKredit);

          // Atur gaya total row
          totalRow.font = { bold: true };
          totalRow.getCell(1).alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          totalRow.getCell(3).alignment = {
            horizontal: "center",
            vertical: "middle",
          };
          totalRow.getCell(6).alignment = {
            horizontal: "right",
            vertical: "middle",
          };
          totalRow.getCell(7).alignment = {
            horizontal: "right",
            vertical: "middle",
          };
          // totalRow.alignment = { horizontal: "center" };
          totalRow.getCell(6).numFmt = "Rp #,##0.00";
          totalRow.getCell(7).numFmt = "Rp #,##0.00";
          totalRow.getCell(8).numFmt = "Rp #,##0.00";

          const borderStyle = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" }, // Double border untuk memisahkan total
            right: { style: "thin" },
          };

          totalRow.eachCell((cell) => {
            cell.border = borderStyle;
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFBDD7EE" }, // Light blue background
            };
          });

          rowIndex++; // Pindah ke baris berikutnya setelah total
        }

        // Tambahkan data transaksi
        const row = worksheet.addRow(); // Data dimulai dari baris ke-4
        row.getCell(1).value = item.tgl;
        row.getCell(2).value = item.noBukti;
        row.getCell(3).value = item.noAcc;
        row.getCell(4).value = item.nameAcc;
        row.getCell(5).value = item.keterangan;
        row.getCell(6).value = item.kategori == "debit" ? item.amount : null;
        row.getCell(7).value = item.kategori == "kredit" ? item.amount : null;
        row.getCell(8).value = null;

        row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
        row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
        row.getCell(3).alignment = { horizontal: "center", vertical: "middle" };

        // Format untuk nilai angka (Debet, Kredit, Saldo)
        row.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
        row.getCell(7).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
        row.getCell(8).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

        const borderStyle = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        // Loop through cells 1 to 5 and apply the border style
        for (let i = 1; i <= headers.length; i++) {
          row.getCell(i).border = borderStyle;
        }

        rowIndex++; // Tambahkan indeks baris
        currentUser = item.noAcc;
        currentUsername = item.nameAcc;
      });

      // Tambahkan total untuk `noAcc` terakhir setelah loop selesai
      if (currentUser !== null) {
        let totalDebit = filteredData
          .filter((d) => d.noAcc === currentUser && d.kategori === "debit")
          .reduce((sum, d) => sum + d.amount, 0);

        let totalKredit = filteredData
          .filter((d) => d.noAcc === currentUser && d.kategori === "kredit")
          .reduce((sum, d) => sum + d.amount, 0);

        const totalRow = worksheet.addRow();

        totalRow.getCell(1).value = "TOTAL";
        totalRow.getCell(2).value = "";
        totalRow.getCell(3).value = currentUser;
        totalRow.getCell(4).value = currentUsername;
        totalRow.getCell(5).value = "";
        totalRow.getCell(6).value = totalDebit != 0 ? totalDebit : "";
        totalRow.getCell(7).value =
          totalKredit != 0 ? Math.abs(totalKredit) : "";
        totalRow.getCell(8).value = totalDebit - Math.abs(totalKredit);

        // Atur gaya total row
        totalRow.font = { bold: true };
        totalRow.getCell(1).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        totalRow.getCell(3).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        totalRow.getCell(6).alignment = {
          horizontal: "right",
          vertical: "middle",
        };
        totalRow.getCell(7).alignment = {
          horizontal: "right",
          vertical: "middle",
        };
        // totalRow.alignment = { horizontal: "center" };
        totalRow.getCell(6).numFmt = "Rp #,##0.00";
        totalRow.getCell(7).numFmt = "Rp #,##0.00";
        totalRow.getCell(8).numFmt = "Rp #,##0.00";

        const borderStyle = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" }, // Double border untuk memisahkan total
          right: { style: "thin" },
        };

        totalRow.eachCell((cell) => {
          cell.border = borderStyle;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFBDD7EE" }, // Light blue background
          };
        });
      }

      let totalDebit = 0;
      let totalKredit = 0;

      filteredData.forEach((item) => {
        if (item.kategori === "debit") {
          totalDebit += item.amount;
        } else if (item.kategori === "kredit") {
          totalKredit += item.amount;
        }
      });

      // Menentukan baris terakhir setelah data
      const lastRowIndex = 5 + filteredData.length + 5; // Baris di bawah data terakhir
      const totalRow = worksheet.getRow(lastRowIndex);

      // Menetapkan label "Total" pada kolom pertama
      // totalRow.getCell(5).value = "TOTAL";
      // totalRow.getCell(5).font = { bold: true };
      // totalRow.getCell(5).alignment = { horizontal: "center" };
      totalRow.getCell(6).font = { bold: true };
      totalRow.getCell(7).font = { bold: true };
      totalRow.getCell(8).font = { bold: true };

      // Menetapkan total debit dan kredit
      totalRow.getCell(6).value = totalDebit;
      totalRow.getCell(7).value = Math.abs(totalKredit);
      totalRow.getCell(8).value = totalDebit - Math.abs(totalKredit);

      // Format angka seperti pada data utama
      totalRow.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
      totalRow.getCell(7).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";
      totalRow.getCell(8).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

      // Membuat border agar rapi
      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" }, // Menggunakan border double untuk total
        right: { style: "thin" },
      };

      // totalRow.getCell(5).border = borderStyle;
      totalRow.getCell(6).border = borderStyle;
      totalRow.getCell(7).border = borderStyle;
      totalRow.getCell(8).border = borderStyle;

      // Atur lebar kolom
      worksheet.columns = [
        { width: 15 },
        { width: 15 },
        { width: 15 },
        { width: 25 },
        { width: 60 },
        { width: 20 },
        { width: 20 },
        { width: 20 },
      ];
    });

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Laporan Buku Besar ${formattedDate}.xlsx`);
  };

  const handleSelectChange = (value, option) => {
    // Perbarui noAcc dan nameAcc dari option yang dipilih
    console.log(option);
    setSelectedData(value);
  };

  return (
    <div>
      {contextHolder}

      <h1 className="text-4xl font-semibold mb-8 text-center">
        Report Buku Besar
      </h1>

      <div className="flex justify-between items-center mb-4 flex-wrap gap-4">
        <div className="flex gap-4 items-center flex-wrap">
          <div className="flex gap-2 items-center">
            <h1 className="font-semibold">Filter : </h1>
            <RangePicker size="middle" onChange={onChange} />
          </div>

          <div className="flex gap-2 items-center">
            <h1 className="font-semibold">Akun : </h1>
            <Select
              className="w-44"
              size="middle"
              loading={loading}
              allowClear
              placeholder="Filter By Akun"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={options}
              onChange={(value, option) => handleSelectChange(value, option)}
            />
          </div>
        </div>

        <div className="">
          {/* <Button
            size="large"
            // type="primary"
            onClick={exportPDF}
            className=" bg-red-500 text-white py-2 px-4 rounded-md mb-4"
          >
            Export PDF
          </Button> */}

          <Button
            size="large"
            // type="primary"
            onClick={exportToExcel}
            className="bg-green-600 text-white py-2 px-4 rounded-md"
          >
            Export Excel
          </Button>
        </div>
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
              // borderColor: "#000",
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <Table
          className={styles.customTable}
          columns={extendedColumn}
          dataSource={data}
          size="middle"
          scroll={{
            x: "max-content",
            // y: 55 * 5,
          }}
        />
      </ConfigProvider>
    </div>
  );
};

export default ReportBukuBesarPage;
